import React, { forwardRef, useEffect, useState } from "react";
import Fontstyling, { tablestyle } from "../../../components/common/comman";
// import MaterialTable from "material-table";
import MaterialTable from "@material-table/core";
import { useParams } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import { IoMdArrowRoundBack } from "react-icons/io";
import theme from "../../../Utils/theme";
import { ConfirmModal } from "../Modal/ConfirmModal";
import EditIcon from "@mui/icons-material/Edit";
import editIcon from "../../../assets/icon/pencil-fill.svg";
import {
  UpdateFileAsApproved,
  UpdateFileInJsonString,
} from "../../../api/User/fileReadWriteApi";
import { useSelector } from "react-redux";
import "./style.css";
import FileUpdateModal from "../Modal/FileUpdateModal";
import moment from "moment/moment";
import toastFile from "../../../Service/ToastFile";

const MuiTable = ({ navigate, object, setIsUpdate }) => {
  const user = useSelector((state) => state.userDetails.value);
  const [witchAction, setWitchAction] = useState("");
  const [isLoading, setIsLoading] = useState({ update: false, approve: false });
  const [isModal, setIsModal] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [data, setData] = useState([]);
  const { FileReadWriteID, FileName, FileJsonString, FileIsApproved } = object;
  let fileData = JSON.parse(object.FileJsonString);
  let th = Object.keys(fileData[0]);
  let column = th.map((tit) => {
    return {
      title: tit,
      field: tit,
      type:
        tit === "Contract Months" || tit === "Paid Month" ? "date" : "numeric",
      sorting: false,
    };
  });

  useEffect(() => {
    let array = JSON.parse(object.FileJsonString);
    setData(
      array.map((item) =>
        item["Contract Months"]
          ? {
              ...item,
              "Contract Months": moment(
                new Date(item["Contract Months"])
              ).format("MMM yyyy"),
            }
          : {
              ...item,
              "Paid Month": moment(new Date(item["Paid Month"])).format(
                "MMM yyyy"
              ),
            }
      )
    );
  }, []);

  const handelFile = () => {
    if (witchAction === "update") {
      setIsLoading((prev) => ({ ...prev, update: true }));
      let new_data = data.map((r) => {
        const { tableData, ...record } = r;
        return record;
      });
      let payload = {
        id: FileReadWriteID,
        modifiedFileJsonString: JSON.stringify([...new_data]),
        modifiedBy: user.UD_id,
      };
      UpdateFileInJsonString(payload)
        .then((res) => {
          // setIsUpdate(true);
          toastFile(res.data, "success");
        })
        .finally((res) => {
          setIsLoading((prev) => ({ ...prev, update: false }));
        });
    } else if (witchAction === "approve") {
      setIsLoading((prev) => ({ ...prev, approve: true }));
      UpdateFileAsApproved(FileReadWriteID, 1)
        .then((res) => {
          if (
            res.data ===
            "File approved successfully and data inserted sucessfully."
          ) {
            setIsUpdate(true);
            toastFile(res.data, "success");
            window.history.back(1);
          } else {
            toastFile(res.data);
          }
        })
        .finally((res) => {
          setIsLoading((prev) => ({ ...prev, approve: false }));
        });
    }
  };

  const tableIcons = {
    Edit: forwardRef((props, ref) => <EditIcon {...props} ref={ref} />),
  };

  return (
    <>
      <FileUpdateModal
        show={modalShow}
        selectedRow={selectedRow}
        onHide={() => setModalShow(false)}
        setData={setData}
        data={data}
      />
      <ConfirmModal
        show={isModal}
        closeModal={() => setIsModal(false)}
        ifYes={()=> {
          handelFile();
          setIsModal(false)
        }}
        action={witchAction}
        massage={
          witchAction === "update"
            ? "Are you sure you want to update file?"
            : "Are you sure you want to approve file?"
        }
      />
      <div className="d-flex mb-3 align-items-center">
        {/* <Button
          variant="transparent"
          className="p-0"
          onClick={() => navigate(-1)}
        >
          <i
            className="bi bi-caret-left-square-fill"
            style={{ fontSize: "1.3em" }}
          />
        </Button> */}

        <IoMdArrowRoundBack
          className="cursor-pointer"
          size={20}
          onClick={() => navigate(-1)}
        />

        <div className="ms-3" style={Fontstyling.heading}>
          {object.FileName.split("/")[object.FileName.split("/").length - 1]}{" "}
        </div>
      </div>

      <MaterialTable
        columns={column}
        data={data}
        icons={tableIcons}
        options={{
          sorting:false,
          draggable: false,
          actionsColumnIndex: -1,
          pageSize: 10,
          paginationType: "normal",
          pageSizeOptions: false,
          search: true,
          paging: data.length > 10,
          filtering: false,
          showTitle: false,
          toolbar: true,
          rowStyle: {
            padding: "0px",
            fontSize: "11px",
            fontFamily: "Arial",
            border: "1px solid #dee2e6",
            textAlign: "left",
            alignContent: "left",
          },
          cellStyle: {
            textAlign: "left",
          },
          headerStyle: {
            padding: "0px",
            backgroundColor: "#18252D",
            color: "#EEF0E2",
            textTransform: "capitalize",
            fontSize: "11px",
            fontFamily: "Arial",
            fontWeight: "700",
            border: "1px solid #dee2e6",
            textAlign: "center",
          },
        }}
        actions={
          FileIsApproved === 0 && [
            {
              icon: () => (
                <img
                  src={editIcon}
                  width="11"
                  className="py-1 cursor-pointer ms-3"
                  alt="edit icon"
                />
              ),
              onClick: (event, rowData, index) => {
                setSelectedRow(rowData);
                setModalShow(true);
              },
            },
          ]
        }
      />
      {FileIsApproved === 0 ? (
        <div className="text-end pt-3">
          <Button
            className="me-3 px-5 text-nowrap"
            style={{
              ...Fontstyling.addnewbutton,
              background: theme.SECONDARY_CHEERFUL_GOLD,
            }}
            onClick={() => {
              setWitchAction("update");
              setIsModal(true);
            }}
          >
            {isLoading.update ? (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="false"
                  style={{ marginRight: "5px" }}
                />
                <span>Updating...</span>
              </div>
            ) : (
              "Update"
            )}
          </Button>
          <Button
            className="px-5 text-nowrap primary-button"
            style={{
              ...Fontstyling.savebutton,
            }}
            onClick={() => {
              setWitchAction("approve");
              setIsModal(true);
            }}
          >
            {isLoading.approve ? (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="false"
                  style={{ marginRight: "5px" }}
                />
                <span>Approving...</span>
              </div>
            ) : (
              "Approve"
            )}
          </Button>
        </div>
      ) : null}
    </>
  );
};

export default MuiTable;
